import { axiosClient } from "../axios";

const baseUrl = "/api/registry/subscription-tiers";

export function getAll() {
  return axiosClient.get(baseUrl);
}

export function create(data) {
  return axiosClient.post(`${baseUrl}`, data);
}

export function update(id, data) {
  return axiosClient.post(`${baseUrl}/${id}`, data);
}

export function remove(id) {
  return axiosClient.delete(`${baseUrl}/${id}`);
}
